  import {
  candidateStatusFilter,
  bgvStatusFilter,
  parsingErrorFilter,
  resumeSuitabilityFilter,
  resumeStatusFilter,
  interviewStatusFilter,
  offerStatusFilter,
  reasonForNotWorkingFilter,
  documentStatusFilter,
  educationAnalysisFilter,
  experienceAnalysisFilter,
  genderFilter,
  reasonForLeavingFilter,
  otherOffersFilter,
  payrollFilter,
  skillMatrixSuitabilityFilter,
  assessmentSuitabilityFilter,
  interviewTypeFilter,
  ownershipFilter,
  availableStausFilter,
} from "./filterconstants";

  export const SUPPORTED_JOB_CATEGORY = [
    { value: 'aiml', label: 'AI/ML' },      
    { value: 'it', label: 'IT & Software' },
    { value: 'vlsi', label: 'Hardware & VLSI' },
    { value: 'wireless', label: 'Wireless & Telecom' },
    { value: 'embedded', label: 'Embedded'},
    { value: 'automotive', label: 'Automotive ' },
    { value: 'teaching', label: 'Teaching' },   
    { value: 'BFSI', label: 'BFSI' },
    { value: 'mechanical', label: 'Mechanical' },
    { value: 'industrial', label: 'Industrial'},      
  ];

  export const SUPPORTED_LOCATION = [
    { value: 'Bengaluru', label: 'Bengaluru' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Gurgaon', label: 'Gurgaon' },
    { value: 'Noida', label: 'Noida'},
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Nagpur', label: 'Nagpur'},
    { value: 'Madurai', label: 'Madurai'}, 
    { value: 'Raipur', label: 'Raipur'},
    { value: 'Chandigarh', label: 'Chandigarh'}, 
    { value: 'Ahmedabad', label: 'Ahmedabad'},
    { value: 'Indore', label: 'Indore'}, 
    { value: 'Nashik', label: 'Nashik' },
    { value: 'Pan India', label: 'Pan India' }, 
    { value: 'Remote', label: 'Remote' },
    { value: 'USA', label: 'USA' },
    { value: 'UK', label: 'UK' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Dubai', label: 'Dubai' },
    { value: 'Other', label: 'Other' },
  ];


 export const ROLE_OPTIONS = {
    it: [
        // ==========================
        // Software Development
        // ==========================
        { value: 'Developer', label: 'Developer' },
        // ==========================
        // Architecture
        // ==========================
        { value: 'Software Architect', label: 'Software Architect' },
        { value: 'Solution Architect', label: 'Solution Architect' },
        { value: 'Enterprise Architect', label: 'Enterprise Architect' },
        { value: 'Cloud Architect', label: 'Cloud Architect' },
        { value: 'Security Architect', label: 'Security Architect' },   
        { value: 'System Architect', label: 'System Architect' },             

        // ==========================
        // Cloud / Infrastructure
        // ==========================
        { value: 'Cloud Engineer', label: 'Cloud Engineer' },
        { value: 'Administrator', label: 'Administrator' },
        { value: 'DevOps Engineer', label: 'DevOps Engineer' },
        { value: 'DevSecOps Engineer', label: 'DevSecOps Engineer' },
        { value: 'Site Reliability Engineer', label: 'Site Reliability Engineer' },
        { value: 'Platform Engineer', label: 'Platform Engineer' },
        { value: 'Infrastructure Engineer', label: 'Infrastructure Engineer' },
        { value: 'Build & Release Engineer', label: 'Build & Release Engineer' },

        // ==========================
        // QA / Testing
        // ==========================
        { value: 'QA Engineer', label: 'QA Engineer' },
        { value: 'Test Engineer', label: 'Test Engineer' },
        { value: 'SDET', label: 'SDET' },
        { value: 'Validation Engineer', label: 'Validation Engineer' },

        // ==========================
        // Security
        // ==========================
        { value: 'Cyber Security Engineer', label: 'Cyber Security Engineer' },
        { value: 'Application Security Engineer', label: 'Application Security Engineer' },

        // ==========================
        // Data
        // ==========================
        { value: 'Data Analyst', label: 'Data Analyst' },
        { value: 'Business Analyst', label: 'Business Analyst' },
        { value: 'SAP Consultant', label: 'SAP Consultant' },

        // ========================== 
        // Systems & Network
        // ==========================
        { value: 'Network Engineer', label: 'Network Engineer' },
        { value: 'System Engineer', label: 'System Engineer' },
        { value: 'Deployment Engineer', label: 'Deployment Engineer' },

        // ==========================
        // Support
        // ==========================
        { value: 'Support Engineer', label: 'Support Engineer' },

        // ==========================
        // SAP / ERP
        // ==========================
        { value: 'Technical', label: 'Technical' },
        { value: 'Functional', label: 'Functional' },
        { value: 'Integration', label: 'Integration' },

        // ==========================
        // Product / Process
        // ==========================,
        { value: 'Product Owner', label: 'Product Owner' },
        { value: 'Scrum Master', label: 'Scrum Master' },
        { value: 'Iteration Manager', label: 'Iteration Manager' },
        { value: 'Technical Writer', label: 'Technical Writer' },

        // ==========================
        // Role wise
        // ==========================
        { value: 'Manager', label: 'Manager' },
        { value: 'Team Leader', label: 'Team Leader' },
        { value: 'Executive', label: 'Executive' },
        { value: 'Leadership', label: 'Leadership' },
        { value: 'Others', label: 'Others' },
    ],
    aiml: [
        // Core Engineering
        { value: 'Developer', label: 'Developer' }, 
        { value: 'Machine Learning Engineer', label: 'Machine Learning Engineer' },
        { value: 'Deep Learning Engineer', label: 'Deep Learning Engineer' },
        { value: 'Generative AI Engineer', label: 'Generative AI Engineer' },
        { value: 'LLM Engineer', label: 'LLM Engineer' },
        { value: 'Agentic AI Engineer', label: 'Agentic AI Engineer' },
        { value: 'Prompt Engineer', label: 'Prompt Engineer' },
        { value: 'RAG Engineer', label: 'RAG Engineer' },
        { value: 'AI Integration Engineer', label: 'AI Integration Engineer' },

        // Data & Analytics
        { value: 'Data Scientist', label: 'Data Scientist' },
        { value: 'Applied Scientist', label: 'Applied Scientist' },
        { value: 'Data Engineer', label: 'Data Engineer' },
        { value: 'Analytics Engineer', label: 'Analytics Engineer' },
        { value: 'Business Intelligence Engineer', label: 'Business Intelligence Engineer' },

        // Specialized AI
        { value: 'Computer Vision Engineer', label: 'Computer Vision Engineer' },
        { value: 'NLP Engineer', label: 'NLP Engineer' },
        { value: 'Speech AI Engineer', label: 'Speech AI Engineer' },
        { value: 'Recommendation Systems Engineer', label: 'Recommendation Systems Engineer' },
        { value: 'Robotics AI Engineer', label: 'Robotics AI Engineer' },
        { value: 'Autonomous Systems Engineer', label: 'Autonomous Systems Engineer' },
        { value: 'Reinforcement Learning Engineer', label: 'Reinforcement Learning Engineer' },

        // Infrastructure & Platform
        { value: 'MLOps Engineer', label: 'MLOps Engineer' },
        { value: 'AI Platform Engineer', label: 'AI Platform Engineer' },
        { value: 'AI Infrastructure Engineer', label: 'AI Infrastructure Engineer' },
        { value: 'Model Deployment Engineer', label: 'Model Deployment Engineer' },
        { value: 'Model Optimization Engineer', label: 'Model Optimization Engineer' },
        { value: 'AI Systems Engineer', label: 'AI Systems Engineer' },
        { value: 'DevOps', label: 'DevOps' },
        { value: 'DevSecOps', label: 'DevSecOps' },
        { value: 'AIOps', label: 'AIOps' },
        { value: 'SRE', label: 'SRE' },

        // Architecture
        { value: 'AI Architect', label: 'AI Architect' },
        { value: 'ML Architect', label: 'ML Architect' },
        { value: 'Solutions Architect', label: 'Solutions Architect' },
        { value: 'Enterprise Architect', label: 'Enterprise Architect' },
        { value: 'Software Architect', label: 'Software Architect' },
        { value: 'Security Architect', label: 'Security Architect' },
        { value: 'Architect', label: 'Architect' },

        // Research
        { value: 'AI Researcher', label: 'AI Researcher' },
        { value: 'ML Researcher', label: 'ML Researcher' },
        { value: 'Research Scientist', label: 'Research Scientist' },
        { value: 'Applied Research Scientist', label: 'Applied Research Scientist' },

        // Testing / Validation / Quality
        { value: 'AI QA Engineer', label: 'AI QA Engineer' },
        { value: 'QA Engineer', label: 'QA Engineer' },
        { value: 'AI Test Engineer', label: 'AI Test Engineer' },
        { value: 'AI Validation Engineer', label: 'AI Validation Engineer' },
        { value: 'Model Validation Engineer', label: 'Model Validation Engineer' },
        { value: 'AI Evaluator', label: 'AI Evaluator' },
        { value: 'AI Safety Engineer', label: 'AI Safety Engineer' },
        { value: 'AI Security Engineer', label: 'AI Security Engineer' },
        { value: 'AI Engineer', label: 'AI Engineer' },

        // Data Preparation
        { value: 'Data Annotator', label: 'Data Annotator' },
        { value: 'Data Labeling Specialist', label: 'Data Labeling Specialist' },
        { value: 'AI Trainer', label: 'AI Trainer' },

        // Product & Consulting
        { value: 'AI Product Manager', label: 'AI Product Manager' },
        { value: 'Technical Product Manager', label: 'Technical Product Manager' },
        { value: 'AI Program Manager', label: 'AI Program Manager' },
        { value: 'AI Solutions Engineer', label: 'AI Solutions Engineer' },
        { value: 'Pre-Sales Engineer', label: 'Pre-Sales Engineer' },
        { value: 'Supprt Engineer', label: 'Support Engineer' },
        { value: 'Business Analyst', label: 'Business Analyst' },

        // Support
        { value: 'Technical Writer', label: 'Technical Writer' },
        { value: 'Technical Support', label: 'Technical Support' },
        { value: 'Administrator', label: 'Administrator' },
        { value: 'Operations', label: 'Operations' },
        { value: 'Manager', label: 'Manager' },
        { value: 'Team Leader', label: 'Team Leader' },
        { value: 'Executive', label: 'Executive' },
        { value: 'Leadership', label: 'Leadership' },
        { value: 'Others', label: 'Others' },   
    ],
    vlsi: [
        // ==========================
        // RTL / Frontend Design
        // ==========================
        { value: 'RTL Engineer', label: 'RTL Engineer' },
        { value: 'Memory Design', label: 'Memory Design' },
        { value: 'Low Power Design', label: 'Low Power Design' },
        { value: 'FPGA Engineer', label: 'FPGA Engineer' },
        // ==========================
        // Verification
        // ==========================
        { value: 'DV', label: 'Design Verification (DV)' },
        { value: 'Functional Verification', label: 'Functional Verification' },
        { value: 'Formal Verification', label: 'Formal Verification' },
        { value: 'Emulation', label: 'Emulation' },
        { value: 'FPGA Prototyping', label: 'FPGA Prototyping' },
        { value: 'Virtual Prototyping', label: 'Virtual Prototyping' },

        // ==========================
        // DFT
        // ==========================
        { value: 'DFT', label: 'DFT' },

        // ==========================
        // Physical Design
        // ==========================
        { value: 'Physical Design', label: 'Physical Design' },
        { value: 'Physical Synthesis', label: 'Physical Synthesis' },

        // ==========================
        // STA / Signoff
        // ==========================
        { value: 'Static Timing Analysis', label: 'Static Timing Analysis' },

        // ==========================
        // Physical Verification
        // ==========================
        { value: 'Physical Verification', label: 'Physical Verification' },

        // ==========================
        // Power / Signal Integrity
        // ==========================
        { value: 'Signal Integrity', label: 'Signal Integrity' },
        { value: 'Power Integrity', label: 'Power Integrity' },
        { value: 'IR Drop Analysis', label: 'IR Drop Analysis' },
        { value: 'Electromigration', label: 'Electromigration' },
        { value: 'Thermal Analysis', label: 'Thermal Analysis' },

        // ==========================
        // Analog / Mixed Signal
        // ==========================
        { value: 'Analog Design', label: 'Analog Design' },
        { value: 'Mixed Signal Design', label: 'Mixed Signal Design' },
        { value: 'RF Design', label: 'RF Design' },
        { value: 'PLL Design', label: 'PLL Design' },
        { value: 'SerDes Design', label: 'SerDes Design' },
        { value: 'Memory Circuit Design', label: 'Memory Circuit Design' },

        // ==========================
        // Layout
        // ==========================
        { value: 'Analog Layout', label: 'Analog Layout' },
        { value: 'Custom Layout', label: 'Custom Layout' },
        { value: 'EMIR', label: 'EMIR' },

        // ==========================
        // Silicon Validation
        // ==========================
        { value: 'Pre-Silicon Validation', label: 'Pre-Silicon Validation' },
        { value: 'Post-Silicon Validation', label: 'Post-Silicon Validation' },
        { value: 'Silicon Validation', label: 'Silicon Validation' },
        { value: 'Silicon Bring-up', label: 'Silicon Bring-up' },
        { value: 'Lab Validation', label: 'Lab Validation' },
        { value: 'Characterization', label: 'Characterization' },
        { value: 'IP Verification', label: 'IP Verification' },

        // ==========================
        // Product Engineering
        // ==========================
        { value: 'ATE Test Engineering', label: 'ATE Test Engineering' },
        { value: 'Product Engineering', label: 'Product Engineering' },
        { value: 'Failure Analysis', label: 'Failure Analysis' },
        { value: 'Reliability Engineering', label: 'Reliability Engineering' },
        { value: 'Yield Engineering', label: 'Yield Engineering' },

        // ==========================
        // CAD / EDA
        // ==========================
        { value: 'CAD', label: 'CAD' },
        { value: 'EDA Tool Development', label: 'EDA Tool Development' },
        { value: 'CAD Automation', label: 'CAD Automation' },
        { value: 'CAD Methodology', label: 'CAD Methodology' },

        // ==========================
        // Embedded Silicon
        // ==========================
        { value: 'Embedded Firmware', label: 'Embedded Firmware' },
        { value: 'Boot Firmware', label: 'Boot Firmware' },
        { value: 'Embedded Software', label: 'Embedded Software' },

        // ==========================
        // Functional Safety & Security
        // ==========================
        { value: 'Functional Safety', label: 'Functional Safety (ISO 26262)' },
        { value: 'Automotive SoC', label: 'Automotive SoC' },
        { value: 'Secure Boot', label: 'Secure Boot' },
        { value: 'Hardware Engineer', label: 'Hardware Engineer' },
        { value: 'PCB Engineer', label: 'PCB Engineer' },        

        // ==========================
        // AI Hardware
        // ==========================
        { value: 'Performance Modeling', label: 'Performance Modeling' },
        { value: 'Virtual Platform', label: 'Virtual Platform Engineer' },        

        // ==========================
        // Packaging
        // ==========================
        { value: 'Package Design', label: 'Package Design' },
        { value: 'Chip Packaging', label: 'Chip Packaging' },
        { value: '2.5D/3D Packaging', label: '2.5D/3D Packaging' },
        { value: 'Chiplet Design', label: 'Chiplet Design' },

        // ==========================
        // Architecture
        // ==========================
        { value: 'ASIC Architect', label: 'ASIC Architect' },
        { value: 'SoC Architect', label: 'SoC Architect' },
        { value: 'System Architect', label: 'System Architect' },

        // ==========================
        // Customer Facing
        // ==========================
        { value: 'Applications Engineer', label: 'Applications Engineer' },
        { value: 'Field Application Engineer', label: 'Field Application Engineer' },
        { value: 'Support Engineer', label: 'Support Engineer' },
        { value: 'Technical Writer', label: 'Technical Writer' },

        // ==========================
        // QA / Testing
        // ==========================
        { value: 'QA Engineer', label: 'QA Engineer' },
        { value: 'Test Engineer', label: 'Test Engineer' },
        { value: 'Automation Engineer', label: 'Automation Engineer' },
        { value: 'Validation Engineer', label: 'Validation Engineer' },

        // ==========================
        // Role wise
        // ==========================
        { value: 'Manager', label: 'Manager' },
        { value: 'Team Leader', label: 'Team Leader' },
        { value: 'Executive', label: 'Executive' },
        { value: 'Leadership', label: 'Leadership' },
        { value: 'Others', label: 'Others' },    

    ],
    embedded: [
        // ==========================
        // Core Embedded Development
        // ==========================
        { value: 'Embedded Software Engineer', label: 'Embedded Software Engineer' },
        { value: 'Embedded Firmware Engineer', label: 'Embedded Firmware Engineer' },
        { value: 'Firmware Developer', label: 'Firmware Developer' },
        { value: 'Real-Time Software Engineer', label: 'Real-Time Software Engineer' },

        // ==========================
        // Linux
        // ==========================
        { value: 'Platform Developer', label: 'Platform Developer' },
        { value: 'Device Driver Developer', label: 'Device Driver Developer' },
        { value: 'BSP Engineer', label: 'BSP Engineer' },
        { value: 'Yocto Engineer', label: 'Yocto Engineer' },
        { value: 'Bootloader Engineer', label: 'Bootloader Engineer' },
        { value: 'System Software Engineer', label: 'System Software Engineer' },

        // ==========================
        // RTOS
        // ==========================
        { value: 'RTOS Engineer', label: 'RTOS Engineer' },

        // ==========================
        // Middleware
        // ==========================
        { value: 'Middleware Engineer', label: 'Middleware Engineer' },
        { value: 'Protocol Stack Developer', label: 'Protocol Stack Developer' },
        { value: 'Networking Software Engineer', label: 'Networking Software Engineer' },

        // ==========================
        // Hardware
        // ==========================
        { value: 'Board Bring-up Engineer', label: 'Board Bring-up Engineer' },
        { value: 'Hardware-Software Integration Engineer', label: 'Hardware-Software Integration Engineer' },
        { value: 'Embedded Systems Engineer', label: 'Embedded Systems Engineer' },
        { value: 'Microcontroller Engineer', label: 'Microcontroller Engineer' },
        { value: 'Microprocessor Engineer', label: 'Microprocessor Engineer' },

        // ==========================
        // IoT
        // ==========================
        { value: 'IoT Engineer', label: 'IoT Engineer' },
        { value: 'Edge AI Engineer', label: 'Edge AI Engineer' },
        { value: 'Connected Devices Engineer', label: 'Connected Devices Engineer' },

        // ==========================
        // Automotive
        // ==========================
        { value: 'Automotive Embedded Engineer', label: 'Automotive Embedded Engineer' },
        { value: 'AUTOSAR Engineer', label: 'AUTOSAR Engineer' },
        { value: 'Functional Safety Engineer', label: 'Functional Safety Engineer' },
        { value: 'ISO 26262 Engineer', label: 'ISO 26262 Engineer' },
        { value: 'ADAS Software Engineer', label: 'ADAS Software Engineer' },

        // ==========================
        // Security
        // ==========================
        { value: 'Embedded Security Engineer', label: 'Embedded Security Engineer' },
        { value: 'Secure Boot Engineer', label: 'Secure Boot Engineer' },
        { value: 'Trusted Execution Environment Engineer', label: 'Trusted Execution Environment Engineer' },

        // ==========================
        // Validation & Testing
        // ==========================
        { value: 'Embedded Test Engineer', label: 'Embedded Test Engineer' },
        { value: 'Embedded Validation Engineer', label: 'Embedded Validation Engineer' },
        { value: 'System Validation Engineer', label: 'System Validation Engineer' },
        { value: 'Integration Engineer', label: 'Integration Engineer' },
        { value: 'QA Engineer', label: 'QA Engineer' },
        { value: 'SDET', label: 'SDET' },
        { value: 'Debugger', label: 'Debugger' },
        { value: 'Firmware Validation Engineer', label: 'Firmware Validation Engineer' },

        // ==========================
        // DevOps / Infrastructure
        // ==========================
        { value: 'DevOps Engineer', label: 'DevOps Engineer' },
        { value: 'Build & Release Engineer', label: 'Build & Release Engineer' },

        // ==========================
        // Architecture
        // ==========================
        { value: 'Embedded Architect', label: 'Embedded Architect' },
        { value: 'Systems Architect', label: 'Systems Architect' },
        { value: 'Solutions Architect', label: 'Solutions Architect' },

        // ==========================
        // Product & Support
        // ==========================
        { value: 'Applications Engineer', label: 'Applications Engineer' },
        { value: 'Field Application Engineer', label: 'Field Application Engineer' },
        { value: 'Technical Support Engineer', label: 'Technical Support Engineer' },
        { value: 'Technical Writer', label: 'Technical Writer' },
        { value: 'Business Analyst', label: 'Business Analyst' },

        // ==========================
        // Role wise
        // ==========================
        { value: 'Manager', label: 'Manager' },
        { value: 'Team Leader', label: 'Team Leader' },
        { value: 'Executive', label: 'Executive' },
        { value: 'Leadership', label: 'Leadership' },
        { value: 'Others', label: 'Others' },        

    ],
    wireless: [
        // ==========================
        // Wireless Software Development
        // ==========================
        { value: 'Developer', label: 'Developer' },
        { value: 'Firmware Engineer', label: 'Firmware Engineer' },
        { value: 'Real-Time Software Engineer', label: 'Real-Time Software Engineer' },
        { value: 'PHY/L1 Engineer', label: 'PHY Engineer' },
        { value: 'DSP Engineer', label: 'DSP Engineer' },
        { value: 'Baseband Engineer', label: 'Baseband Engineer' },
        { value: 'RF Design Engineer', label: 'RF Design Engineer' },
        { value: 'RF Validation Engineer', label: 'RF Validation Engineer' },
        { value: 'RF Test Engineer', label: 'RF Test Engineer' },
        { value: 'Antenna Engineer', label: 'Antenna Engineer' },
        { value: 'Microwave Engineer', label: 'Microwave Engineer' },

        // ==========================
        // Validation & Testing
        // ==========================
        { value: 'Validation Engineer', label: 'Validation Engineer' },
        { value: 'Field Test Engineer', label: 'Field Test Engineer' },        
        { value: 'Protocol Test Engineer', label: 'Protocol Test Engineer' },
        { value: 'Interoperability Engineer', label: 'Interoperability Engineer' },
        { value: 'Network Test Engineer', label: 'Network Test Engineer' },
        { value: 'RAN Test Engineer', label: 'RAN Test Engineer' },        
        { value: 'Performance Engineer', label: 'Performance Engineer' },
        { value: 'QA Engineer', label: 'QA Engineer' },
        { value: 'SDET', label: 'SDET' },

        // ==========================
        // Network
        // ==========================
        { value: 'RAN Engineer', label: 'RAN Engineer' },
        { value: 'Core Network Engineer', label: 'Core Network Engineer' },
        { value: 'OSS/BSS Engineer', label: 'OSS/BSS Engineer' },
        { value: 'Network Optimization Engineer', label: 'Network Optimization Engineer' },
        { value: 'Network Planning Engineer', label: 'Network Planning Engineer' },
        { value: 'Network Performance Engineer', label: 'Network Performance Engineer' },

        // ==========================
        // Deployment & Support
        // ==========================
        { value: 'Deployment Engineer', label: 'Deployment Engineer' },
        { value: 'Commissioning Engineer', label: 'Commissioning Engineer' },
        { value: 'Installation Engineer', label: 'Installation Engineer' },
        { value: 'Integration Engineer', label: 'Integration Engineer' },
        { value: 'Operations Engineer', label: 'Operations Engineer' },
        { value: 'Technical Support Engineer', label: 'Technical Support Engineer' },
        { value: 'Field Application Engineer', label: 'Field Application Engineer' },

        // ==========================
        // Architecture
        // ==========================
        { value: 'Software Architect', label: 'Software Architect' },
        { value: 'System Architect', label: 'System Architect' },        
        { value: 'Network Architect', label: 'Network Architect' },
        { value: 'Solutions Architect', label: 'Solutions Architect' },
        { value: 'Modem Architect', label: 'Modem Architect' },
        { value: 'Platform Architect', label: 'Platform Architect' },
        { value: 'L1 Architect', label: 'L1 Architect' },

        // ==========================
        // Misc
        // ==========================
        { value: 'Business Analyst', label: 'Business Analyst' },
        // ==========================
        // Product / Process
        // ==========================,
        { value: 'Product Owner', label: 'Product Owner' },
        { value: 'Scrum Master', label: 'Scrum Master' },
        { value: 'Iteration Manager', label: 'Iteration Manager' },
        { value: 'Technical Writer', label: 'Technical Writer' },
        { value: 'Marketing', label: 'Marketing' },
        { value: 'Sales', label: 'Sales' },

        // ==========================
        // Role wise
        // ==========================
        { value: 'Manager', label: 'Manager' },
        { value: 'Team Leader', label: 'Team Leader' },
        { value: 'Executive', label: 'Executive' },
        { value: 'Leadership', label: 'Leadership' },
        { value: 'Others', label: 'Others' },

        { value: 'Modem Test Engineer', label: 'Modem Test Engineer' },
        { value: 'UE Test Engineer', label: 'UE Test Engineer' },
        { value: 'Debug Engineer', label: 'Debug Engineer' },

    ],   

    mechanical: [
        { value: 'Wiring Harness', label: 'Wiring Harness' },
        { value: 'Others', label: 'Others' },
    ],  
    };

  export const ROLE_TYPE_OPTIONS = [
    { value: 'Individual Contributor', label: 'Individual Contributor' },
    { value: 'Technical Lead', label: 'Technical Lead' },
    { value: 'Team Lead', label: 'Team Lead' },
    { value: 'Principle Engineer', label: 'Principle Engineer' },
    { value: 'Project Manager', label: 'Project Manager' },
    { value: 'Program Manager', label: 'Program Manager' },
    { value: 'Manager', label: 'Manager' },
    { value: 'Senior Manager', label: 'Senior Manager' },
    { value: 'Engineering Manager', label: 'Engineering Manager' },
    { value: 'Delivery Manager', label: 'Delivery Manager' },
    { value: 'Product Manager', label: 'Product Manager' },    
    { value: 'Associate Director', label: 'Associate Director' },
    { value: 'Director', label: 'Director' },
    { value: 'Senior Director', label: 'Senior Director' },
    { value: 'AVP', label: 'AVP (Assistant Vice President)' },
    { value: 'VP', label: 'VP (Vice President)' },
    { value: 'SVP', label: 'SVP (Senior Vice President)' },
    { value: 'EVP', label: 'EVP (Executive Vice President)' },
    { value: 'CXO', label: 'CXO' },
    ];  
    
  export const WORK_OPTIONS = [
    { label: "WFO", value: "WFO" },
    { label: "WFH", value: "WFH" },
    { label: "Hybrid", value: "Hybrid" },
    { label: "Remote", value: "Remote" },
    { label: "Any", value: "Any" },    
    ];    

  export const EDUCATION_OPTIONS = [
    { value: "BE", label: "BE" },
    { value: "BTech", label: "BTech" },
    { value: "ME", label: "ME" },
    { value: "MTech", label: "MTech" },
    { value: "PhD", label: "PhD" },
    { value: "BCA", label: "BCA" },
    { value: "MCA", label: "MCA" },
    { value: "Diploma", label: "Diploma" },
    { value: "BCom", label: "BCom" },
    { value: "MCom", label: "MCom" },
    { value: "BEd", label: "BEd" },
    { value: "MEd", label: "MEd" },
    { value: "BSc", label: "BSc" },
    { value: "MSc", label: "MSc" },
    { value: "MBBS", label: "MBBS" },
    { value: "MD/MS", label: "MD/MS" },
    { value: "MS (Abroad)", label: "MS (Abroad)" },
    { value: "BS (Abroad)", label: "BS (Abroad)" },
    { value: "PhD (Abroad)", label: "PhD (Abroad)" },
  ]

  export const FILTER_DURATION_OPTIONS = [
    { value: "All", label: "All" },
    { value: "1", label: "Last 1 hr" },
    { value: "4", label: "Last 4 hrs" },
    { value: "12", label: "Last 12 hrs" },                        
    { value: "24", label: "Last 24 hrs" },
    { value: "36", label: "Last 36 hrs" },
    { value: "48", label: "Last 2 days" },
    { value: "72", label: "Last 3 days" },
    { value: "96", label: "Last 4 days" },
    { value: "120", label: "Last 5 days" },
    { value: "168", label: "Last 7 days" },                    
    { value: "360", label: "Last 15 days" },
    { value: "720", label: "Last 30 days" },
    { value: "1440", label: "Last 60 days" },                                                                                             
    { value: "2160", label: "Last 90 days" },     
    { value: "4320", label: "Last 180 days" },
    { value: "8760", label: "Last 365 days" },     
  ]; 
  
  export const RDB_FILTER_DURATION_OPTIONS = [
    { value: "All", label: "All" },
    { value: "8", label: "Last 8 hrs" },
    { value: "12", label: "Last 12 hrs" },                        
    { value: "24", label: "Last 24 hrs" },
    { value: "36", label: "Last 36 hrs" },
    { value: "168", label: "Last 7 days" },                    
    { value: "360", label: "Last 15 days" },
    { value: "720", label: "Last 30 days" },
    { value: "1440", label: "Last 60 days" },                                                                                             
    { value: "2160", label: "Last 90 days" },     
    { value: "4320", label: "Last 6 Months" },
    { value: "8760", label: "Last 1 Year" },  
    { value: "17520", label: "Last 2 Years" },     
  ]; 

  export const OWNERSHIP_OPTIONS = [
    { value: "By Team", label: "Team" },
    { value: "By Vendor", label: "Vendor" },
    { value: "By Candidate", label: "NuJobs" },
    { value: "Through Career Page", label: "Career Page" },                        
    { value: "By Automation", label: "Automation" },      
    
  ];
  
  export const VIEW_FILTER_CONFIG = [
    {
      key: "Candidate Status",
      mode: "multiple",
      options: candidateStatusFilter,
    },
    {
      key: "Resume Suitability",
      mode: "multiple",
      options: resumeSuitabilityFilter,
    },
    {
      key: "Resume Status",
      mode: "multiple",
      options: resumeStatusFilter,
    },
    {
      key: "Candidate Status Updated By",
      mode: "multiple",
      options: [],
    },
    {
      key: "Payroll",
      mode: "multiple",
      options: payrollFilter,
    },
    {
      key: "Skill Matrix Suitablity",
      mode: "multiple",
      options: skillMatrixSuitabilityFilter,
    },
    {
      key: "Assessment Suitability",
      mode: "multiple",
      options: assessmentSuitabilityFilter,
    },

    {
      key: "Interview Status",
      mode: "multiple",
      options: interviewStatusFilter,
    },
    {
      key: "Interview Type",
      mode: "multiple",
      options: interviewTypeFilter,
    },

    {
      key: "Offer Status",
      mode: "multiple",
      options: offerStatusFilter,
    },
    {
      key: "Updated By",
      mode: "multiple",
      options: [],
    },
    {
      key: "Education Analysis",
      mode: "multiple",
      options: educationAnalysisFilter,
    },
    {
      key: "Experience Analysis",
      mode: "multiple",
      options: experienceAnalysisFilter,
    },
    {
      key: "Parsing Errors",
      mode: "multiple",
      options: parsingErrorFilter,
    },
    {
      key: "Gender",
      mode: "multiple",
      options: genderFilter,
    },
    {
      key: "Reason For Leaving",
      mode: "multiple",
      options: reasonForLeavingFilter,
    },
    {
      key: "Reason For Not Working",
      mode: "multiple",
      options: reasonForNotWorkingFilter,
    },
    {
      key: "Other Offers",
      mode: "multiple",
      options: otherOffersFilter,
    },
    {
      key: "Ownership",
      mode: "multiple",
      options: ownershipFilter,
    },
    {
      key: "Source By",
      mode: "multiple",
      options: [],
    },
  ];
  
  export const SUPPORTED_EVENT_TYPE = [
    { value: 'Hackathon', label: 'Hackathon' },      
    { value: 'Walkin Drive', label: 'Walkin Drive' },
    { value: 'Virtual Drive', label: 'Virtual Drive' },
    { value: 'JobFair', label: 'JobFair' },    
  ];